import {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';

const useDisabledDelay = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [disabled, setDisabled] = useState(false);
  const timerId = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    if (disabled) {
      timerId.current = setTimeout(() => {
        setDisabled(false);
        clearTimeout(timerId.current);
      }, 5000);
    }

    return (): void => {
      clearTimeout(timerId.current);
    };
  }, [disabled]);

  return [disabled, setDisabled];
};

export { useDisabledDelay };
